import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcWebsiteOptIn = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcWebsiteOptIn"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip0_6138_3143)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z",
  fill: "white",
  stroke: "#E6E6E6"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip1_6138_3143)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.3333 10.667H10.6666C9.38325 10.667 8.34492 11.717 8.34492 13.0003L8.33325 27.0003C8.33325 28.2837 9.38325 29.3337 10.6666 29.3337H29.3333C30.6166 29.3337 31.6666 28.2837 31.6666 27.0003V13.0003C31.6666 11.717 30.6166 10.667 29.3333 10.667ZM10.6666 16.5003H22.9166V20.5837H10.6666V16.5003ZM10.6666 22.917H22.9166V27.0003H10.6666V22.917ZM29.3333 27.0003H25.2499V16.5003H29.3333V27.0003Z",
  fill: "url(#pathTo_Svg__Paint0_Linear_6138_3143)"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pathTo_Svg__Paint0_Linear_6138_3143",
  x1: "9.00024",
  y1: "11.5",
  x2: "30.5002",
  y2: "28.5",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#30A3E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.415",
  stopColor: "#5865F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FF9075"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip0_6138_3143"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip1_6138_3143"
}, /*#__PURE__*/React.createElement("rect", {
  width: "28",
  height: "28",
  fill: "white",
  transform: "translate(6 6)"
}))));
export { IconIcWebsiteOptIn as default };
//# sourceMappingURL=IconIcWebsiteOptIn.js.map